import {action, computed, observable, runInAction} from 'mobx'
import {_encodeParam, get, json} from "../../../utils/ajax";
import {handleSearchAndPage, setStore} from '../../../utils/Utils'
import {message} from 'antd'

class LetterNoticeStore {
    @observable loading;
    @observable searchFields; //搜索字段
    @observable letterNoticeList;   //通知单列表
    @observable letterNoticePage;   //通知单页面
    @observable letterNoticePagination;
    @observable addModal;   //新增弹窗是否显示属性
    @observable addFields;   //新增字段
    @observable carseriesList; //车系列表
    @observable factoryList; //基地列表
    @observable letterPath; //通知书保存路径
    @observable option; //用于判断新增father/son
    @observable info;   //保存table同一行数据
    @observable statisticsList;
    @observable statisticsPage;   //下载统计页面
    @observable statisticsPagination;
    @observable searchFieldsStatistics; //搜索条件  设为空
    @observable allowedAdd; //允许上传（附件添加成功）
    @observable carseriesCodeList; //新增时车系列表
    @observable factoryNameList; //新增时基地列表
    @observable countryAreaList;//查询时国家地区列表（针对共享）
    @observable countryAreaOptions //国家地区Options
    @observable fileList
    @observable modelTitle //模态框名称
    @observable only //通知书编号唯一
    @observable modelStatus
    @observable modal   //模态框

    constructor() {
        this.loading = false;
        this.searchFields = {
            letterName: '',
            letterCode: '',
            isShare: '',
            factoryName: '',
            carseriesCode: '',
            creatorName: '',
            startTime: '',
            endTime: '',
            sharePlace: ''
        };
        this.letterNoticeList = [];
        this.letterNoticePage = {
            current: 0,
            total: 1,
            showQuickJumper: true,
        };
        this.letterNoticePagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        };
        this.addModal = false;
        this.addFields = {
            letterCode: '',
            letterName: '',
            factoryName: [],
            carseriesCode: [],
            letterPath: '',
            level: '',
            pId: '',
            id: '',
            changeInitiator: ''
        }
        this.carseriesList = [];
        this.factoryList = [];
        this.letterPath = '';
        this.option = [];
        this.info = [];
        this.statisticsPage = {
            current: 0,
            total: 1,
            showQuickJumper: true
        };
        this.statisticsPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFieldsStatistics = {
            letterCode: '',
            letterName: ''
        }
        this.allowedAdd = false
        this.statisticsList = []
        this.carseriesCodeList = []
        this.factoryNameList = []
        this.countryAreaList = []
        this.countryAreaOptions = []
        this.fileList = []
        this.modelTitle = ''
        this.only = ''
        this.modelStatus = false
        this.modal = false
    }


    /**
     * 下载统计主页面
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    initLetterNoticeDownloadPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchResult = handleSearchAndPage(page, this.statisticsPagination, this.searchFieldsStatistics);
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternoticedownload/getPage:search`, searchResult);
        runInAction(() => {
            this.statisticsList = res.content || [];
            this.statisticsPagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共${res.totalElements}条`
            };
            this.loading = false
        })
    };

    /**
     * 工程变更新增
     */
    @action
    AddBox = (record, option) => {
        this.loading = true
        this.addModal = true;
        this.modelTitle = option;
        if (record) { //修改
            this.info = record;
            record.carseriesCode = record.carseriesCode ? (typeof (record.carseriesCode) === 'string' ? record.carseriesCode.split(' ') : record.carseriesCode) : [];
            record.factoryName = record.factoryName ? (typeof (record.factoryName) === 'string' ? record.factoryName.split('/') : record.factoryName) : [];
            this.letterPath = record.letterPath;
            this.addFields = {...this.addFields, ...record}
        } else {  //新增
            this.option = option;
            this.carseriesCodeList = []
            this.factoryNameList = []
            this.addFields = {
                letterCode: '',
                letterName: '',
                factoryName: [],
                carseriesCode: [],
                letterPath: '',
                level: '',
                pId: '',
                id: '',
                changeInitiator: ''
            };
        }
        this.loading = false
        this.initFactoryList()
    }

    //下载统计-搜索框绑值
    @computed
    get searchFieldsStatisticsModal() {
        let fields = {
            letterCode: {value: this.searchFieldsStatistics.letterCode},
            letterName: {value: this.searchFieldsStatistics.letterName}
        };
        return fields;
    }

    //下载统计-改变时绑定搜索框值
    @action
    searchFieldsStatisticsChangeModal(changeFields) {
        const fields = {...this.searchFieldsStatisticsModal, ...changeFields}
        const searchFieldsStatistics = {
            letterCode: fields.letterCode.value ? fields.letterCode.value.trim() : '',  //去除空格
            letterName: fields.letterName.value ? fields.letterName.value.trim() : '',  //去除空格
        };
        this.searchFieldsStatistics = searchFieldsStatistics;
    }

    //下载统计-清空搜索框
    @action
    clearSearchFieldsStatistics = () => {
        this.loading = true;
        this.searchFieldsStatistics = {
            letterName: '',
            letterCode: '',
        };
        this.loading = false
    };

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 下载统计下载
     * 导出全部
     */
    getDownloadUrl = () => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternoticedownload/export/excel`
        return `${url}?${_encodeParam()}`
    }


    /**
     * 通知单主页面
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    initLetterNoticePage = async (page) => {
        runInAction(() => {
            this.loading = true
        });
        let searchResult = handleSearchAndPage(page, this.letterNoticePagination, this.searchFields);
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/get_page:search`, searchResult);
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.letterNoticePagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            };
            this.letterNoticeList = this.setNumber(res.content) || [];
            this.loading = false
        })
    }

    /**
     * 设置当前列表序号，记录最后一个序号
     * @returns {{letterName: {value: string}, isShare: {value: string}}}
     */
    @action
    setNumber(arr) {
        if (!arr) {
            return
        }
        let arr2 = arr;
        arr2.forEach((item, index) => {
            if (index === 0) {
                item.num = 1
            } else {
                if (arr2[index - 1].children) {
                    item.num = arr2[index - 1].num + arr2[index - 1].children.length + 1
                } else {
                    item.num = arr2[index - 1].num + 1
                }
            }
            // index === 0 ? item.number = 1 : arr2[index-1].children? item.number = arr2[index-1].number+arr2[index-1].children.length+1 : item.number = arr2[index-1].number+1

            if (item.children) {
                item.children.forEach((item2, index2) => {
                    item2.num = item.num + index2 + 1
                })
            }
        });

        return arr2
    }

    //主页面搜索框绑值
    @computed
    get searchFieldsModal() {
        let fields = {
            letterName: {value: this.searchFields.letterName},
            letterCode: {value: this.searchFields.letterCode},
            isShare: {value: this.searchFields.isShare},
            factoryName: {value: this.searchFields.factoryName},
            carseriesCode: {value: this.searchFields.carseriesCode},
            creatorName: {value: this.searchFields.creatorName},
            startTime: {value: this.searchFields.startTime},
            endTime: {value: this.searchFields.endTime},
            sharePlace: {value: this.searchFields.sharePlace},
        };
        return fields;
    }

    //改变时绑定搜索框值
    @action
    searchFieldsChangeModal(changeFields) {
        const fields = {...this.searchFieldsModal, ...changeFields}
        const searchFields = {
            letterName: fields.letterName.value ? fields.letterName.value.trim() : '',
            letterCode: fields.letterCode.value ? fields.letterCode.value.trim() : '',
            isShare: (fields.isShare.value === '是') ? 1 : ((fields.isShare.value === '否') ? 0 : ''),
            factoryName: fields.factoryName.value ? fields.factoryName.value : '',
            carseriesCode: fields.carseriesCode.value ? fields.carseriesCode.value : '',
            creatorName: fields.creatorName.value ? fields.creatorName.value.trim() : '',
            startTime: (fields.rangePicker && fields.rangePicker.value && fields.rangePicker.value.length) ? fields.rangePicker.value[0].format('YYYY-MM-DD') : '',
            endTime: (fields.rangePicker && fields.rangePicker.value && fields.rangePicker.value.length) ? fields.rangePicker.value[1].format('YYYY-MM-DD') : '',
            sharePlace: fields.sharePlace.value ? fields.sharePlace.value : '',

        }
        this.searchFields = searchFields;
    }

    //清空搜索框
    @action
    clearSearchFields = () => {
        this.searchFields = {
            letterName: '',
            letterCode: '',
            isShare: '',
            factoryName: [],
            carseriesCode: [],
            creatorName: '',
            startTime: '',
            endTime: '',
            sharePlace: ''
        };
        this.initLetterNoticePage()
    };

    //删除
    @action
    doDelete = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/delete/${id}`);
        if (res.status === 1) {
            message.success("删除成功")
        } else {
            message.warn("无法删除非该用户创建的数据")
        }
        runInAction(() => {
            this.initLetterNoticePage(this.letterNoticePage);
            this.loading = false
        })
    };

    /**
     * 新增Box绑值
     */
    @computed
    get addFieldModel() {
        let fileds = {
            letterCode: {value: this.addFields.letterCode},
            letterName: {value: this.addFields.letterName},
            letterPath: {value: this.addFields.letterPath},
            level: {value: this.addFields.level},
            pId: {value: this.addFields.pId},
            id: {value: this.addFields.id},
            changeInitiator: {value: this.addFields.changeInitiator},
            factoryNameList: {value: this.factoryNameList},
            countryAreaList: {value: this.countryAreaList}
        }
        return fileds
    }

    /**
     * 绑定新增窗口的值
     * @param changeFields
     */
    @action
    addFieldChangeModel(changeFields) {
        const fields = {...this.addFieldModel, ...changeFields}
        this.addFields = {
            letterCode: fields.letterCode.value,
            letterName: fields.letterName.value,
            letterPath: fields.letterPath.value,
            level: fields.level.value,
            factoryNameList: fields.factoryNameList.value,
            countryAreaList: fields.countryAreaList.value,
            changeInitiator: fields.changeInitiator.value
        }
    }


    /**
     * 保存
     * 通知单属性是factoryName，carseriesCode，但是新增的form表单存的是factoryNameList，carseriesCodeList
     * 最后处理两个list 使其变成/XX/XX/XX/的形式存在对应属性里面
     */
    @action
    save = async (comment, option) => {
        this.loading = true
        let info = this.info;
        let data = {
            'letterCode': comment.letterCode,
            'letterName': comment.letterName,
            'factoryName': comment.factoryName?comment.factoryName.join(","):'',
            'carseriesCode': comment.carseriesCode.join(" "),
            'letterPath': this.letterPath,
            'level': '',
            'pId': '',
            'id': '',
            'changeInitiator': comment.changeInitiator
        }
        // if (option === 'addSon') {
        if (this.modelTitle) {
            data.level = 2;
            data.id = info.id;
            data.pId = info.id;
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/update`, data);
        } else {
            data.level = 1;
            data.id = info.id;
            data.pId = 0
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/add`, data);
            runInAction(() => {
                if (res.data === false) {
                    message.warning('通知书编号已存在')
                }
            })
        }

        runInAction(() => {
            this.loading = false
            this.addModal = false
            this.initLetterNoticePage(this.letterNoticePage.current);
            this.allowedAdd = false
            this.modal = false
        })
    }


    @action
    numberingUnique = async (value) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/get_by_notice_code`, {noticeCode: value});
        return res
    }

    /**
     * 查询国家地区
     */
    @action
    initCountryArea = async () => {
        runInAction(() => {
            this.loading = true
        })
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '国家和地区/'})
        let countryAreaList = res.children || []
        let countryAreaOptions = []
        countryAreaList.forEach(item => {
            countryAreaOptions.push({
                label: item.name,
                value: item.name
            })
        })
        runInAction(() => {
            this.countryAreaList = countryAreaList
            this.countryAreaOptions = countryAreaOptions
            this.loading = false
        })
    }

    /**
     * 查询基地(字典表)
     */
    @action
    initFactoryList = async () => {
        runInAction(() => {
            this.loading = true
        });
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '基地/'})
        // console.log(res)
        runInAction(() => {
            this.factoryList = res.children || [];
            this.loading = false
        })
    };

    /**
     * 查询车系
     */
    @action
    initCarSeriesList = async () => {
        runInAction(() => {
            this.loading = true
        });
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseries:search`)
        runInAction(() => {
            this.carseriesList = Array.isArray(res) ? res : []
            this.loading = false
        })
    };

    /**
     * 给附件地址赋值
     */
    @action
    setFilePath = (letterPath) => {
        this.letterPath = letterPath
    }

    /**
     * 设置上传文件列表
     */
    @action
    setFileList(fileList) {
        this.fileList = fileList
    }

    /**
     * 关闭弹窗
     */
    @action
    closeAddBox = async () => {
        this.modal = false
        this.addModal = false
        this.modal = false
        this.fileList = []
    }

    /**
     * 共享
     */
    @action
    share = async (list, id) => {
        runInAction(() => {
            this.loading = true
        })

        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/shareletter/id/${id}`, list);
        message.success('操作成功')
        runInAction(() => {
            this.initLetterNoticePage(this.letterNoticePagination.current);
            this.loading = false
        })
    }
    //取消共享
    @action
    cancelShare = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/cancelshare/id/${id}`);
        message.success('已取消共享');
        runInAction(() => {
            this.initLetterNoticePage(this.letterNoticePagination.current);
            this.loading = false
        })
    }

    @action
    uploadLoading = (flag) => {
        runInAction(() => {
            this.loading = flag;
        })
    }

    /**
     * 发送邮件
     * @returns {Promise.<void>}
     */
    @action
    sendMail = async () => {
        runInAction(() => {
            this.loading = true
        })
        await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/send_email`);
        message.success('发送邮件成功！');
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 设置下载通知单url
     * 导出全部
     */
    getUrl = (id) => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/download/${id}`
        return `${url}?${_encodeParam()}`
    }

}

export default new LetterNoticeStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/LetterNotice/store.js